// extracted by mini-css-extract-plugin
export default {"header":"Header_header__zJwht","main-image":"Header_main-image__myEX9"};